var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.3999C3.79086 2.3999 2 4.11913 2 6.2399V17.7599C2 19.8806 3.79086 21.5999 6 21.5999H18C20.2091 21.5999 22 19.8806 22 17.7599V6.2399C22 4.11913 20.2091 2.3999 18 2.3999H6ZM6 7H8V12H6V7ZM10 12V17H8V12H10ZM12 12H10V7H12V12ZM14 12H12V17H14V12ZM16 12H14V7H16V12ZM16 12V17H18V12H16Z",
    fill: "#FDB426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWave);
export default __webpack_public_path__ + "static/media/squareWave.bb2683224a1527fac4a3b46f83a762c8.svg";
export { ForwardRef as ReactComponent };